import React, { useState } from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import {serverRootUrl} from "../../config";
import Carousel from "react-elastic-carousel";
import Flex from "./../../Flex";
import Circle from "./../../Circle";
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import Thumbs from "../../Components/Carousel/Thumbs";
import * as ReactGA from "react-ga";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import clsx from 'clsx';
import MobileThumbs from "../Carousel/MobileThumbs";
import Responsive from "../Responsive/Responsive";
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import useDetectPrint from "use-detect-print";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            height: 524,
            maxHeight: 524,
            overflowY: 'hidden'
        },
        xl: {
            maxHeight: 454
        },
        l: {
            maxHeight: 337
        },
        rootMobile: {
            height: 300,
            maxHeight: 300,
            overflowY: 'hidden'
        },
        carousel: {
            position: 'relative',
            ['@media (min-width:1200px)']: {
                maxWidth: 699
            },
        },
        progress: {
            position: 'absolute',
        },
        imageMobile: {
            width: '100%'
        },
        image: {
            width: '100%',
            '@media print' : {
                maxWidth: 700,
                position: 'absolute',
                left: 0
            }
        },
        noImage: {
            position: 'absolute',
            width: '100%',
            background: '#ccc',
            borderBottom: '1px solid #ccc',
        },
        noImageLabel: {
            fontFamily: 'Arial',
            fontWeight: '400',
            lineHeight: '1.5',
            letterSpacing: '0.00938em',
            position: 'absolute',
            fontSize: '.8rem',
            top: '55%',
            left: '50%',
            marginLeft: '-35px',
            color: '#000'
        },
        cameraIcon: {
            position: 'absolute',
            fontSize: '3rem',
            top: '40%',
            left: '50%',
            marginLeft: '-23px',
            color: '#fff'
        },
        comingSoonCont: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: 524,
            backgroundColor: '#eee',
        },
        comingSoonContMobile: {
            height: 300,
        },
        comingSoon: {
            position: 'absolute',
            width: 'auto',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            color: '#000',
            top: 'calc(50% - 18px)',
            left: 'calc(50% - 47px)',
            textAlign: 'center',
            cursor: 'pointer'
        },
        expand: {
            position: 'absolute',
            right: 10,
            top: 10,
            cursor: 'pointer',
            zIndex: 1000,
            backgroundColor: '#fff',
            borderRadius: 4,
            padding: '0 2px',
            height: 32,
            opacity: .8,
            '& svg': {
                fontSize: '2rem',
            },
            ['@media (min-width:701px)']: {
                '& svg': {
                    fontSize: '2rem',
                }
            },
            '@media print' : {
                display: 'none !important'
            }
        },
        expanded: {
            width: '100%',
            backgroundColor: '#fff',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 2000,
            overflow: 'scroll',
            textAlign: 'center',
            paddingBottom: 10,
            borderBottom: '1px dashed #ccc',
        },
        closeIcon: {
            position: 'fixed',
            right: 10,
            top: 10,
            cursor: 'pointer',
            backgroundColor: '#fff',
            borderRadius: 4,
            padding: '0 2px',
            height: 32,
            opacity: .8,
            zoom: 1.2,
            border: '1px solid #ccc',
            ['@media (max-width:700px)']: {
                zoom: 1.5,
                fontSize: '2rem',
                border: 'none'
            },
        },
        expandProgress: {
            marginTop: 10,
            width: '100%'
        },
        printHidden: {
            '@media print' : {
                display: 'none !important'
            }
        }

    }});

export default function ItemCarousel(props) {

    const classes = useStyles();

    const [imageIndex, setImageIndex] = React.useState(0);
    const [transitionMs, setTransitionMs] = React.useState(500);
    const [loading, setLoading] = React.useState(true);
    const [wrapperWidth, setWrapperWidth] = React.useState();
    const [expanded, setExpanded] = React.useState();
    const [expandLoaded, setExpandLoaded] = React.useState();

    const isPrinting = useDetectPrint();

    const item = props.item;

    if (!item) {
        return null;
    }

    const image = item.image;

    const images = item
        ? item.images && item.images.length ? item.images : (image ? [{image: image, description: item.title}] :  []) : [];

    const isMobile = props.isMobile;
    const header = props.header;

    const switchImage = (e) => {
        if (transitionMs !== 500) {
            setTransitionMs(500);
        }
        const edgeX = isMobile ? 0 : (window.innerWidth - 900)/2;
        const mouseX = e.clientX - edgeX;
        if (mouseX < 300) {
            prevImage();
        } else {
            nextImage();
            console.log('1')
        }
        ReactGA.event({
            category: 'User',
            action: 'image_switch',
            label: item.sn
        });
    }

    const prevImage = (e) => {
        if (imageIndex <= 0) {
            carousel.goTo(item.images.length - 1);
        } else {
            carousel.slidePrev();
        }
    };

    const nextImage = (e) => {
        if (imageIndex >= item.images.length - 1) {
            carousel.goTo(0);
        } else {
            carousel.slideNext();
        }
    };

    const onNavClick = (index) => {
        onThumbClick(index);
    }

    const onThumbClick = index => {
        setLoading(true);
        setTransitionMs(1);
        carousel.goTo(index);
        ReactGA.event({
            category: 'User',
            action: 'thumb_click',
            label: item.sn
        });
    };

    const onExpandClick = () => {
        if (!expanded) {
            setExpandLoaded(false);
        }
        setExpanded(!expanded);
    };

    const onExpandLoaded = () => {
        setExpandLoaded(true)
    };

    const getWrapperWidth = () => {
        const wrapper = document.getElementById('mainWrapper');
        if (!wrapper) {
            return;
        }

        let newWrapperWidth = props.isMobile ? wrapper.clientWidth : wrapper.clientWidth - 300;
        if (newWrapperWidth && wrapperWidth !== newWrapperWidth) {
            if (isPrinting) {
                newWrapperWidth = 700;
            }
            setWrapperWidth(newWrapperWidth);
        }
    }

    const onLoaded = () => {
        setLoading(false);
    };

    const onResize = () => {
        getWrapperWidth();
    }


    let carousel;

    let addClass = props.size === 'xl' ? classes.xl :  props.size === 'l' ? classes.l : null;

    let ext = props.size === 'xl' || props.size === 'xxl' || props.size === 'xxxl' ? 'l.jpg?2' : '.jpg?2';

    const height = Math.round(wrapperWidth / 1.33333);

    console.log('wrapperWidth', wrapperWidth);

    const progressLeft = props.size === 'xxxl' ? 699/2 - 20 : wrapperWidth/2 - 20;

    return (
        <>
        <Responsive onResize={onResize}/>
            {expanded && images[imageIndex]?
                <div className={classes.expanded}>
                    <CloseIcon className={classes.closeIcon} onClick={onExpandClick}/>
                    {!expandLoaded ? <LinearProgress className={classes.expandProgress}/> : null}
                    <img src={'/'+images[imageIndex].image.replace('.jpg', 'l.jpg')}
                         alt={images[imageIndex].description ? images[imageIndex].description : header}
                         title={images[imageIndex].description ? images[imageIndex].description : header}
                        onLoad={onExpandLoaded}
                        />
                </div> : null}
            {wrapperWidth ?
                <>
                    <div className={isMobile ? clsx(classes.rootMobile, addClass) : clsx(classes.root, addClass)} style={
                        props.size !== 'xxxl' ? {
                            height: height,
                            maxHeight: height
                        } : {}
                    }>
                    <div className={classes.carousel}>
                        <div className={classes.expand} onClick={onExpandClick}>
                            <AspectRatioIcon/>
                        </div>
                        {images.length ?
                            <>
                            {loading ? <CircularProgress className={classes.progress} style={{
                                left: progressLeft,
                                top: progressLeft / 1.333
                            }}/> : null}
                                <Carousel showArrows={false} ref={ref => (carousel = ref)} transitionMs={transitionMs}
                                    preventDefaultTouchmoveEvent={true}
                                    enableAutoPlayenableAutoPlay={true}
                                    enableSwipe={isMobile}
                                    onChange={(e) => {setImageIndex(e.index)}}
                                    renderPagination={({ pages, activePage, onClick }) => {
                                      return (
                                          <Flex isMobile={isMobile} size={props.size} wrapperWidth={getWrapperWidth()}>
                                              {pages.map((page, i) => {
                                                  const isActivePage = activePage === page
                                                  return (
                                                      <Circle
                                                          key={page}
                                                          onClick={() => onNavClick(i)}
                                                          active={isActivePage}
                                                      />
                                                  )
                                              })}
                                          </Flex>
                                      )
                                    }}>

                                    {images.map((im, index) =>
                                        <>
                                            <div className={classes.media}>
                                                {index === 0 || index === imageIndex || index === imageIndex + 1 ? <img
                                                    className={clsx(isMobile ? classes.imageMobile : classes.image, index === 0 ? null : classes.printHidden)}
                                                    alt={im.description ? im.description : header}
                                                     title={im.description ? im.description : header}
                                                     src={serverRootUrl + '/' + im.image.replace('.jpg', ext)} onClick={switchImage}
                                                     onLoad={onLoaded}
                                                    style={{
                                                        display: Math.abs(index - imageIndex) < 2 ? 'block' : 'none'
                                                    }}
                                                /> : null}</div>
                                        </>

                                    )}
                                </Carousel>
                                {props.size === 'xxxl' ? <Thumbs item={item} header={props.header} onClick={onThumbClick}/> : null}
                            </>: null}
                        {!images.length ? <div className={clsx(classes.comingSoonCont, isMobile ? classes.comingSoonContMobile : null)}>
                            <div className={classes.comingSoon}>
                            <PhotoCameraIcon/><br/>
                            coming soon</div></div> : null}
                        </div>
                    </div>
                    {props.size !== 'xxxl' ? <MobileThumbs wrapperWidth={wrapperWidth} item={item} header={props.header}
                                                               onClick={onThumbClick}/> : null}
                  </> : null}
            </>
    );
}
